import { render, staticRenderFns } from "./MuseumsTable.vue?vue&type=template&id=e015693c&"
import script from "./MuseumsTable.vue?vue&type=script&lang=js&"
export * from "./MuseumsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports